import { render, staticRenderFns } from "./TraspasosExportView.vue?vue&type=template&id=010533df&"
import script from "./TraspasosExportView.vue?vue&type=script&lang=js&"
export * from "./TraspasosExportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports